import { useContext } from "react";
import UserContext from "../context/UserContext";

const MyContext = () => useContext(UserContext);

export default MyContext;
